import swal from "sweetalert";
import {
  CREATE_UNDERGONE_SURGERY_FAIL,
  CREATE_UNDERGONE_SURGERY_REQUEST,
  CREATE_UNDERGONE_SURGERY_SUCCESS,
  UPDATE_UNDERGONE_SURGERY_FAIL,
  UPDATE_UNDERGONE_SURGERY_REQUEST,
  UPDATE_UNDERGONE_SURGERY_SUCCESS,
} from "../../ActionType/UndergoneSurgeryTypes/UndergoneSurgeryTypes";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const createUndergoneSurgeryAction =
  (visit_id, surgery, suplies, date) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CREATE_UNDERGONE_SURGERY_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "undergonesurgery/create",
        { surgery, suplies, visit_id, date },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        swal({
          title: "Good job!",
          text: "Surgery  was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: CREATE_UNDERGONE_SURGERY_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_UNDERGONE_SURGERY_FAIL,
        payload: [],
        error: error.response.data,
      });
    }
  };

export const udpateUndergoneSurgeryAction =
  (id, visit_id, surgery, suplies, date) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: UPDATE_UNDERGONE_SURGERY_REQUEST,
      payload: [],
    });
    try {
      const response = await api.put(
        "undergonesurgery/update/" + id,
        { had_surgery: surgery, suplies, visit_id, date },
        config
      );
      
      const { status, data } = response;
      // console.log("res : ",response)
      if (status == 200) {
        swal({
          title: "Good job!",
          text: "Surgery  was Updated Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: UPDATE_UNDERGONE_SURGERY_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_UNDERGONE_SURGERY_FAIL,
        payload: [],
        error: error.response.data,
      });
    }
  };
